import { headingStyles } from "../../assets/styles/CommonStyles";
import { React, Typography, Outlet, TopBar, AppLayout, Box, useNavigate } from "../../utils/globalImports"
import { useTheme } from "@mui/material/styles"

const lookupTabs = [
  { name: "Client Category", path: "/lookup/client-category" },
  { name: "Client Region", path: "/lookup/client-region" },
  { name: "Fee Stage Area", path: "/lookup/fee-stage-area" },
  { name: "Tags", path: "/lookup/tags" },
  { name: "Personnel", path: "/lookup/personnel" },
];

const LookupLayout: React.FC = () => {
  const theme = useTheme();
  const navigate = useNavigate();

  const handleTabChange = async (_event: React.SyntheticEvent, newValue: string) => {
    navigate(newValue);
  }
  
  return (
    <div style={{display: "flex", flexDirection: "column", height: "100%",overflow: "hidden"}}>
      <AppLayout>
        <Typography
                  sx={headingStyles}
                >
          Look Up Table
        </Typography>

        <Box sx={{ }}>
          <TopBar tabs={lookupTabs} onChange={handleTabChange} />
        </Box>
        <Box sx={{ marginTop: {sx:0,md:"-34px"},
          display: "flex",
          flex: 1,
          flexDirection: "column",
          minHeight: 0,
         }}>
          <Outlet />
        </Box>
      </AppLayout>
    </div>
  );
};

export default LookupLayout;
